export const styleGenerator = ({ actionType, serverAppTheme }) => {
  const isLandScape = true;
  const selectedSeats = []; //TODO: Migrate selected Seats logic later
  const fullWidthModal = {
    position: 'relative',
    margin:
      actionType.type === 'unsentMove' ||
      actionType.type === 'sentMove' ||
      actionType.type === 'discount'
        ? ''
        : '0',
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    pointerEvents: 'auto',
    backgroundColor: serverAppTheme?.popUp_bg,
    backgroundClip: 'padding-box',
    height:
      actionType.type === 'unsentMove' ||
      actionType.type === 'sentMove' ||
      actionType.type === 'discount'
        ? '100%'
        : '',
    border: serverAppTheme?.popupBorder,
    boxShadow: serverAppTheme?.popUp_box_shadow,
  };
  const parentContainer = { color: serverAppTheme?.primary_text };
  const crossIcon = {
    right: '16px',
    zIndex: '999',
    fontSize: '18px',
    color: serverAppTheme?.iconcolor,
  };
  const buttonContainer = {
    padding:
      (actionType.type === 'unsentMove' ||
        actionType.type === 'sentMove' ||
        actionType.type === 'discount') &&
      isLandScape
        ? '4px 60px 0px'
        : !isLandScape
        ? '0px 8%'
        : '',
    alignItems: 'baseline',
  };
  const tableStyle = {
    width: isLandScape ? '300px' : '148px',
    height: '44px',
    color: selectedSeats.includes('table')
      ? '#000'
      : serverAppTheme?.primary_text,
    border: serverAppTheme?.popupBorder,
    background: selectedSeats.includes('table')
      ? serverAppTheme?.selected
      : serverAppTheme?.OFF_Premise_Btn,
  };
  const cancelButton = {
    backgroundColor: serverAppTheme?.OFF_Premise_Btn,
    border: serverAppTheme?.cancleBtn_Border,
    color: serverAppTheme?.cancleBtn_font,
    borderRadius: '8px',
  };
  const moveButton = {
    backgroundColor: serverAppTheme?.secondaryBtn,
    color: serverAppTheme?.btn_font_color,
    borderRadius: '8px',
  };
  const modal = {
    backgroundColor: serverAppTheme?.popUp_bg,
    borderRadius: '16px',
    border: serverAppTheme?.popupBorder,
    boxShadow: serverAppTheme?.popUp_box_shadow,
    width: '486px',
    margin: 'auto',
    minHeight: '216px',
    padding: '1.5rem',
    position: 'relative',
  };
  const noButton = {
    backgroundColor: serverAppTheme?.OFF_Premise_Btn,
    border: serverAppTheme?.cancleBtn_Border,
    color: serverAppTheme?.cancleBtn_font,
    borderRadius: '8px',
  };
  const yesButton = {
    backgroundColor: serverAppTheme?.secondaryBtn,
    color: serverAppTheme?.btn_font_color,
    borderRadius: '8px',
  };
  const disabledButton = {
    backgroundColor: serverAppTheme?.secondaryBtnDisabled,
    color: serverAppTheme?.secondary_btn_disable_text,
    borderRadius: '8px',
    opacity: 1,
  };

  return {
    fullWidthModal,
    parentContainer,
    crossIcon,
    buttonContainer,
    tableStyle,
    cancelButton,
    moveButton,
    disabledButton,
    modal,
    noButton,
    yesButton,
  };
};
